import React from 'react';
import { useRouter } from 'next/router';
import Image from 'next/image';

import useMediaQuery from 'utils/useMediaQuery';
import { Calculate } from 'components/sections/Calculate';
import { LoanType } from 'enums/LoanType';
import Symbol from 'assets/logotype/symbol.svg';

import styles from './LoanHero.module.scss';

const TOTAL_COST_DEFAULT = 120000;

export const LoanHero: React.FC = () => {
  const { query } = useRouter();

  const intialCarLoanCalculatorData = {
    'total-cost': Number(query['total-cost']) || TOTAL_COST_DEFAULT,
    licensePlate: query.licensePlate,
    'campaign-code': query.coupon || '',
  };
  const [isMobile, setIsMobile] = React.useState(Boolean);
  const max768px = useMediaQuery('(max-width: 768px)');

  React.useEffect(() => {
    setIsMobile(max768px);
  }, [max768px]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.inner}>
        {!isMobile && <Symbol className={styles.symbol} />}
        <div className={styles.texts}>
          <h1>Billån med experthjälp</h1>
          <p>
            Samma billån som hos bilhandlaren. <br />
            Samma ränta för alla.
          </p>
          <ul>
            <li>Köp bil av vem du vill med experthjälp</li>
            <li>Billån med restvärde</li>
            <li>Baka in garanti i lånet</li>
          </ul>
          <p className={styles.smallText}>1000-tals nöjda kunder</p>

          <div className={styles.trustpilot}>
            <span>Utmärkt</span>
            <Image
              width={120}
              height={24} // Lägg till höjd för optimal responsivitet
              src="/assets/icons/logo/Trustpilot_rating.svg"
              alt="Trustpilot betyg"
            />
            <a href="https://se.trustpilot.com/review/blipp.se" target="_blank" rel="noreferrer">
              <Image
                width={100}
                height={24} // Lägg till höjd för optimal responsivitet
                src="/assets/icons/logo/Trustpilot_brandmark_dark.svg"
                alt="Trustpilot logotyp"
              />
            </a>
          </div>
        </div>
        <div className={styles.calculator}>
          <div className={styles.calcWrapper} id="calculator">
            <Calculate
              initialData={intialCarLoanCalculatorData}
              imageSrc="/assets/images/calculator-woman-trustpilot.png"
              loanType={LoanType.NordeaLoan}
              hideHeadline
              hideImage
            />
          </div>
        </div>
      </div>
    </div>
  );
};
